import { track } from '@bnnvara/analytics/src/track';
import { IconButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { Close as CloseIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Close';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';

import { BrandCard } from '../../cards/BrandCard/BrandCard';
import { useIsFollowedByUser } from '../../FollowBrand/useIsFollowedByUser';
import * as S from './styled';

export function FollowingBrandCard({ id, name, backgroundImageUrl, brandId }) {
  const theme = useTheme();
  const { toggle } = useIsFollowedByUser(brandId);

  async function handleClick() {
    track('profiel', 'click', 'ontvolgen');

    await toggle();
  }

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 4"
      columnEndXl="span 3"
      key={id}
    >
      <S.RemovableCardContainer>
        <S.RemoveButtonContainer>
          <IconButton color={theme.base.red} onClick={handleClick}>
            <CloseIcon />
          </IconButton>
        </S.RemoveButtonContainer>

        <BrandCard name={name} image={backgroundImageUrl} />
      </S.RemovableCardContainer>
    </GridItem>
  );
}

FollowingBrandCard.propTypes = {
  backgroundImageUrl: PropTypes.string,
  id: PropTypes.bool.isRequired,
  brandId: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
};
